"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NCapMembershipSchema = exports.NCapDSRBRequestSchema = exports.NCapGenerateDSRBRequestSchema = exports.NCapRenderParamsSchema = exports.NCapRenderParamsMainDataSchema = exports.NCapTestimonialsResponseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var SST_1 = require("./SST");
exports.NCapTestimonialsResponseSchema = zod_1.z
    .object({
    uid: zod_1.z.string(),
})
    .merge(SST_1.SSTDetailedSchema);
exports.NCapRenderParamsMainDataSchema = zod_1.z.object({
    picture: zod_1.z.string(),
    name: zod_1.z.string(),
    nationality: zod_1.z.string(),
    dob: zod_1.z.string(),
    awardedOn: zod_1.z.string(),
    pyaNumber: zod_1.z.string(),
    qualifications: zod_1.z.number(),
    obs: zod_1.z.string(), // THIS is a string now as per PMM-579
    loaDays: zod_1.z.number(),
    actualSeaService: zod_1.z.coerce.string(),
    standByService: zod_1.z.coerce.string(),
    yardService: zod_1.z.coerce.string(),
    watchKeepinService: zod_1.z.coerce.string(),
    watchKeepingEngineer: zod_1.z.coerce.string(),
    nightWatchHours: zod_1.z.coerce.string(),
});
exports.NCapRenderParamsSchema = zod_1.z
    .object({
    qualificationSummary: zod_1.z.any(),
    seaServiceSummary: zod_1.z.any(),
})
    .merge(exports.NCapRenderParamsMainDataSchema);
/**
{
  "templateUid": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  "issuerUid": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  "data": {
    "credential": {
      "issuedOn": "2024-07-15T07:47:14.332Z",
      "expires": "string",
      "qualification": "string",
      "comment": "string",
      "signed": true,
      "externalIdentifier": "string"
    },
    "recipient": {
      "firstName": "string",
      "lastName": "string",
      "email": "string",
      "birthdate": "string",
      "country": "string",
      "countryId": "string",
      "phone": "string",
      "address": "string",
      "secondaryIdentifier": "string"
    }
  },
  "renderParams": {}
} */
exports.NCapGenerateDSRBRequestSchema = zod_1.z.object({
    uid: zod_1.z.string().optional(),
    templateUid: zod_1.z.string(),
    issuerUid: zod_1.z.string(),
    data: zod_1.z.object({
        credential: zod_1.z.object({
            id: zod_1.z.string(),
            issuedOn: zod_1.z.coerce.date(),
            expires: zod_1.z.string().nullish(),
            qualification: zod_1.z.string().optional(),
            comment: zod_1.z.string().optional(),
            signed: zod_1.z.boolean().optional(),
            externalIdentifier: zod_1.z.string().optional(),
        }),
        recipient: zod_1.z.object({
            firstName: zod_1.z.string(),
            lastName: zod_1.z.string(),
            email: zod_1.z.string(),
            birthdate: zod_1.z.string().nullish(),
            country: zod_1.z.string(),
            countryId: zod_1.z.string().optional(),
            phone: zod_1.z.string(),
            address: zod_1.z.string(),
            secondaryIdentifier: zod_1.z.string().optional(),
        }),
    }),
    // This, I'm not so sure.
    renderParams: exports.NCapRenderParamsSchema,
    UserId: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
});
exports.NCapDSRBRequestSchema = exports.NCapGenerateDSRBRequestSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.NCapMembershipSchema = zod_1.z.object({
    memberId: zod_1.z.number(), // ??
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    email: zod_1.z.string(),
    membershipNo: zod_1.z.boolean(), // ??
    expiry: zod_1.z.string().datetime(),
    active: zod_1.z.boolean(), // ??
    type: zod_1.z.string(), // ??
    dateJoined: zod_1.z.string().datetime(),
});
//# sourceMappingURL=NCap.js.map